import { Chip, TextField, Typography } from "@mui/material";
import "./SubmitFinalWorkPage1.scss";
import GGToolTip from "../../components/UtilityComponents/GGToolTip/GGToolTip";
import GGButton from "../../components/CommonComponents/GGButton/GGButton";
import { useState } from "react";
import SubmitOriginalFilesTable from "./SubmitOriginalFilesTable";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import LockIcon from "@mui/icons-material/Lock";
import React from "react";
import GGDialogueBox, { dialogueType } from "../../components/UtilityComponents/GGDialogueBox/GGDialogueBox";
import { Order } from "../../Models/Order";
import UploadImagesSectionDraggable, { UploadableImage } from "../../components/UtilityComponents/UploadImagesSection/UploadImagesSection";

interface SubmitFinalWorkPage1Props {
    nextPage: () => void;
    filesToUpload: File[];
    previewImagesToUpload: UploadableImage[];
    setPreviewImagesToUpload: (images: UploadableImage[]) => void;
    setFilesToUpload: React.Dispatch<React.SetStateAction<File[]>>;
    order: Order | null;
    remarks: string;
    setRemarks: (val: string) => void;
}

const  SubmitFinalWorkPage1 = (props: SubmitFinalWorkPage1Props) => {
  const [showConfirmationDialogBox, setShowConfirmationDialogBox] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  // handling upload files section
  const fileDeleteHandler = (name: string) => {
    props.setFilesToUpload((prevFiles) => prevFiles.filter((file) => file.name !== name));
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const newFiles: File[] = Array.from(event.target.files).map(
        (file, index) => {
          return file;
        }
      );
      props.setFilesToUpload((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const fileInputRef = React.useRef<HTMLInputElement | null>(null);

  const handleUploadButtonClick = () => {
    document.getElementById("fileInputDialog")?.click();
  };

  // submit button click handler
  const handleSubmitButtonClick = () => {
    if (!props.remarks.trim()) {
      setErrorMessage("Remarks are required.");
      setShowErrorDialog(true);
      return;
    }
    setShowConfirmationDialogBox(true);
  };

  const confirmToNextPage = () => {
    setShowConfirmationDialogBox(false);
    props.nextPage();
  };

  return (
    <div className="submit-final-work-page-1-container">
      <div className="submit-final-work-modal-content">
        <div className="heading-and-tooltips">
          <Typography className="modal-content-item">
            Upload screenshots of final work
          </Typography>
          <GGToolTip
            title="Why Screenshots?"
            body="Original files can only be shared when the work done is full and final. Screenshots help update the client for the progress and prevents potential fraud and unethical practices. All screenshots are watermarked by the system."
          >
            <Chip
              size="small"
              className="why-preview-chip"
              label="Why Preview?"
            ></Chip>
          </GGToolTip>
        </div>
        
        <UploadImagesSectionDraggable 
          editMode={true} 
          maxLimit={100} 
          images={props.previewImagesToUpload} 
          setImages={props.setPreviewImagesToUpload} 
        />
        
        <div className="modal-content-item upload-original-files-heading-row">
          <div className="heading-and-tooltips">
            <Typography>Upload Final Original Files</Typography>
            <Chip
              className="protected-chip"
              size="small"
              label="Protected"
              icon={<LockIcon className="lock-icon"></LockIcon>}
            ></Chip>
            <GGToolTip
              title="Your files are protected"
              body="The client will be able to download the original files only when they have approved & accepted your work. Till then, they will only be able to see the preview screenshots."
            >
              <Chip className="how-chip" size="small" label="How?"></Chip>
            </GGToolTip>
          </div>
          <GGButton
            className="upload-files-btn"
            disableClickShrink
            startIcon={<FileUploadIcon />}
            onClick={handleUploadButtonClick}
          >
            Upload Files
          </GGButton>
          <input
            id="fileInputDialog"
            type="file"
            multiple
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileUpload}
          ></input>
        </div>
        <SubmitOriginalFilesTable
          files={props.filesToUpload}
          fileDeleteHandler={fileDeleteHandler}
        ></SubmitOriginalFilesTable>
        <Typography className="modal-content-item">Remarks*</Typography>
        <TextField
          id="outlined-multiline-static"
          required
          multiline
          rows={4}
          value={props.remarks}
          onChange={e => props.setRemarks(e.target.value)}
        />


      <GGDialogueBox type={dialogueType.Info} successHandler={confirmToNextPage} isOpen={showConfirmationDialogBox} message='Are you sure to upload the selected files and proceed to submit final work?' closeHandler={() => { setShowConfirmationDialogBox(false) }} />
      <GGDialogueBox
          type={dialogueType.Error}
          isOpen={showErrorDialog}
          message={errorMessage}
          closeHandler={() => setShowErrorDialog(false)} 
          successHandler={()=>{}}
        />
      </div>
      <div className="submit-work-btn-container">
            <GGButton
            className="submit-work-btn"
            variant="contained"
            disabled={props.filesToUpload.length === 0}
            disableClickShrink
            size="small"
            onClick={handleSubmitButtonClick}
            startIcon={<AssignmentTurnedInOutlinedIcon />}
          >
            Proceed
          </GGButton>
      </div>
    </div>
  );  
};

export default SubmitFinalWorkPage1;
